<template>
  <div class="bs3-margin-top">
    <i v-if="loading" class="fa-light fa-3x fa-spinner fa-pulse fa-fw"></i>
    <table v-else class="table table-sm table-condensed table-striped table-hover">
      <thead>
        <tr>
          <th>{{ 'dictionary.media.insertion.kpi.date' | i18nText(pDictionary) }}</th>
          <th class="text-right">{{ 'dictionary.media.insertion.kpi.' + pKpiName + '.cost-for.planned' | i18nText(pDictionary) }}</th>
          <th class="text-center">{{ 'dictionary.media.insertion.kpi.' + pKpiName + '.nb.planned' | i18nText(pDictionary) }}</th>
          <th class="text-center">{{ 'dictionary.media.insertion.kpi.' + pKpiName + '.nb.planned.cumulative' | i18nText(pDictionary) }}</th>
          <th class="text-right">{{ 'dictionary.media.insertion.kpi.' + pKpiName + '.cost-per.planned' | i18nText(pDictionary) }}</th>
          <th class="text-right">{{ 'dictionary.media.insertion.kpi.' + pKpiName + '.cost-for.actual' | i18nText(pDictionary) }}</th>
          <th class="text-center">{{ 'dictionary.media.insertion.kpi.' + pKpiName + '.nb.actual' | i18nText(pDictionary) }}</th>
          <th class="text-center">{{ 'dictionary.media.insertion.kpi.' + pKpiName + '.nb.actual.cumulative' | i18nText(pDictionary) }}</th>
          <th class="text-right">{{ 'dictionary.media.insertion.kpi.' + pKpiName + '.cost-per.actual' | i18nText(pDictionary) }}</th>
          <th class="text-center">{{ 'dictionary.media.insertion.kpi.progress' | i18nText(pDictionary) }}</th>
          <th class="text-center">{{ 'dictionary.media.insertion.kpi.analysis' | i18nText(pDictionary) }}</th>
          <th class="text-center">{{ 'dictionary.media.insertion.kpi.analysis.cumulative' | i18nText(pDictionary) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="sheetData.daily.size === 0">
          <td colspan="12">{{ 'dictionary.general.none' | i18nText(pDictionary) }}</td>
        </tr>
        <tr v-for="dailyData in sheetData.daily" :key="dailyData.date">
          <td>{{dailyData.date}}</td>
          <td class="text-nowrap text-right">{{dailyData.plannedCostFor | money(pCurrencies, sheetData.currencyId) | emptyToDash}}</td>
          <td class="text-center">{{dailyData.plannedQuantity | emptyToDash}}</td>
          <td class="text-center">{{dailyData.plannedCumulativeQuantity | emptyToDash}}</td>
          <td class="text-nowrap text-right">{{dailyData.plannedCostPer | money(pCurrencies, sheetData.currencyId) | emptyToDash}}</td>
          <td class="text-nowrap text-right">{{dailyData.actualCostFor | money(pCurrencies, sheetData.currencyId) | emptyToDash}}</td>
          <td class="text-center">{{dailyData.actualQuantity | emptyToDash}}</td>
          <td class="text-center">{{dailyData.actualCumulativeQuantity | emptyToDash}}</td>
          <td class="text-nowrap text-right">{{dailyData.actualCostPer | money(pCurrencies, sheetData.currencyId) | emptyToDash}}</td>
          <td class="text-nowrap text-center">{{dailyData.actualQuantityProgress | percent(pDictionary) | emptyToDash}}</td>
          <td class="text-nowrap text-center">{{dailyData.actualPacing | percent(pDictionary) | emptyToDash}}</td>
          <td class="text-nowrap text-center">{{dailyData.actualCumulativePacing | percent(pDictionary) | emptyToDash}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "MetricKpiInfoSheetSection",
  mixins: [FormatMixin],
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: {
      type: Object,
      required: true
    },
    pKpiName: {
      type: String,
      required: true
    },
    pDataListInput: Object,
  },
  data: function () {
    return {
      loading: true,
      sheetData: null
    }
  },
  methods: {
    refreshSheet: function () {
      let _component = this;
      _component.loading = true;
      _component.sheetData = null;
      $.ajax({
               type: "POST",
               url: "/mediaplan/app/endpoints/json-api/metrics/kpis/" + _component.pKpiName.toUpperCase() + "/sheet?",
               data: JSON.stringify(_component.pDataListInput),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (data) {
        _component.sheetData = data;
        _component.loading = false;
      });
    }
  },
  mounted: function () {
    this.refreshSheet();
  }
}
</script>

<style scoped>

</style>